import { render } from "./ZapiPizzaTag.vue?vue&type=template&id=3bc38a3b&scoped=true"
import script from "./ZapiPizzaTag.vue?vue&type=script&lang=js"
export * from "./ZapiPizzaTag.vue?vue&type=script&lang=js"

import "./ZapiPizzaTag.vue?vue&type=style&index=0&id=3bc38a3b&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc38a3b"]])

export default __exports__